<template>
  <div class="not-auth">
    <template v-if="$msal.accounts[0]?.idTokenClaims.extension_vmlink">
      <a href="https://dafaterweb-dev.saudismb.com/eirad/">
        <img
          class="not-auth__logo"
          src="@/assets/images/logo.svg"
          alt="Eirady"
        />
      </a>
      <h2 class="not-auth__heading">
        مرحبـــــــــاً بــــــك {{ $msal.accounts[0].name }}
      </h2>

      <div class="vms-container">
        <template
          v-for="(
            vmLink, index
          ) in $msal.accounts[0].idTokenClaims.extension_vmlink.split(',')"
          :key="index"
        >
          <div>
            <vm-card :vmLink="vmLink" />
          </div>
        </template>
      </div>
      <router-link to="/logout" class="link"> الدخول بحساب اخر؟</router-link>
    </template>
    <template v-else>
      <img
        class="not-auth__logo"
        src="@/assets/images/welcome-charc.svg"
        alt="Eirady"
      />
      <h2 class="not-auth__heading" style="max-width: 70rem">
        أهلا بك يا {{ this.$msal.accounts[0].name }}, أنت غير مشترك لدينا في
        إيرادي للاشتراك قم بإنشاء حساب
      </h2>
      <a :href="eiradWPLink + 'pricing'" class="btn btn-primary"
        >إنشاء اشتراك جديد في ايرادي</a
      >
      <router-link to="/logout" class="link"> تسجيل خروج </router-link>
    </template>
  </div>
</template>

<script>
import VmCard from "@/components/VmCard.vue";
export default {
  components: { VmCard },
  data() {
    return {
      submitBtn: null,
      goEiradLink: process.env.VUE_APP_GO_EIRAD_URI,
      eiradWPLink: process.env.VUE_APP_EIRAD_WP_URI,
    };
  },
  mounted() {
    console.log("msal:>", this.$msal.accounts[0]);
    //  setTimeout(() => {
    //     const response =  fetch(vmLink)
    //       const data =  response.json()
    // }, "1000")
  },
};
</script>

<style lang="scss">
@mixin flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.not-auth {
  @include flex-center;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  text-align: center;

  &__logo {
    width: 22rem;
  }
  &__heading {
    font-size: 3.6rem;
    font-weight: 700;
    margin: 4rem 0;
  }
  .vms-container {
    @include flex-center;
    flex-wrap: wrap;
    margin-bottom: 2rem;
  }
  .vm-card {
    width: 15rem;
    height: 17rem;
    border-radius: 5px;
    margin: 1rem;
    background-color: #fff;
    flex-direction: column;
    &,
    &__logo {
      @include flex-center;
    }
    &:hover {
      border: 1px solid #7b9a41;
      cursor: pointer;
    }
    &__logo {
      border-radius: 50%;
      width: 6rem;
      height: 6rem;
      background-color: #d9d9d988;
      color: #7b9a41;
      font-size: 2rem;
      font-weight: 700;
      text-transform: uppercase;
    }
    &__user {
      font-weight: 700;
      font-size: 1.5rem;
      margin-top: 2rem;
    }
    &__vmlink {
      font-size: 1.2rem;
    }
  }
  .link {
    color: #7b9a41;
    text-decoration: underline;
    cursor: pointer;
    margin-top: 2rem;
  }
}
</style>